import { routes } from "App";
import { IconHomeKhachHang } from "assets/icons/home";
import { IconHomeLichHen } from "assets/icons/home";
import { IconHomeTaiLieu } from "assets/icons/home";
import { IconHomeNhanSu } from "assets/icons/home";
import { IconHomeCamera } from "assets/icons/home";
import { IconHomeDanhBa } from "assets/icons/home";
import { IconHomeTrungTamTroGiup } from "assets/icons/home";
import { IconHomeChat } from "assets/icons/home";
import { IconHomeThongBao } from "assets/icons/home";
import { IconHomeCaiDat } from "assets/icons/home";
import { IconHomeTinTuc } from "assets/icons/home";
import { IconHomeHoSoPhuongTien } from "assets/icons/home";
import { IconHomeThietBi } from "assets/icons/home";
import { IconHomeDonHang } from "assets/icons/home";
import { IconHomeTinNhan } from "assets/icons/home";
import { IconHomeVanHanh } from "assets/icons/home";
import { IconHomeTiepThiLienKet } from "assets/icons/home";
import { ALL_PERMISSION, warningPermission, hasPermissionWithSetting } from "constants/permission";
import React, { useMemo } from "react";
import "./index.scss";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useModalDirectLinkContext } from "components/ModalDirectLink";
import { useDispatch, useSelector } from "react-redux";
import { IconHomeTorichat } from "assets/icons/home";
import { setMenu } from "actions";

export default function HomeMenu() {
  const { setUrlForModalDirectLink } = useModalDirectLinkContext();
  const history = useHistory();
  const menuData = useSelector((state) => state?.common?.menu);
  const setting = useSelector((state) => state.setting);
  const dispatch = useDispatch();
  const listMenu = useMemo(() => {
    const menu = [
      {
        icon: <IconHomeVanHanh />,
        title: "Vận hành",
        permission: ALL_PERMISSION.MANAGE_RECORD.permission,
        path: routes.accreditation.path,
        keyEnable: ALL_PERMISSION.MANAGE_RECORD.keyEnable
      },
      {
        icon: <IconHomeKhachHang />,
        title: "Khách hàng",
        permission: ALL_PERMISSION.MANAGE_CUSTOMER.permission,
        path: routes.listCustomer.path,
        keyEnable: ALL_PERMISSION.MANAGE_CUSTOMER.keyEnable
      },
      {
        icon: <IconHomeTinNhan />,
        title: "Tin Nhắn",
        permission: ALL_PERMISSION.MANAGE_SMS.permission,
        path: routes.sms.path,
        keyEnable: ALL_PERMISSION.MANAGE_SMS.keyEnable
      },
      {
        icon: <IconHomeLichHen />,
        title: "Lịch hẹn",
        permission: ALL_PERMISSION.MANAGE_SCHEDULE.permission,
        path: routes.customerSchedule.path,
        keyEnable: ALL_PERMISSION.MANAGE_SCHEDULE.keyEnable
      },
      // {
      //   icon: <IconHomeHoaDon />,
      //   title: "Hóa đơn",
      //   permission: ALL_PERMISSION.MANAGE_BILLING.permission,
      //   path: routes.receipt.path,
      //   keyEnable: ALL_PERMISSION.MANAGE_BILLING.keyEnable
      // },
      {
        icon: <IconHomeDonHang />,
        title: "Đơn hàng",
        permission: ALL_PERMISSION.MANAGE_ORDER.permission,
        path: routes.listOrder.path,
        keyEnable: ALL_PERMISSION.MANAGE_ORDER.keyEnable
      },
      {
        icon: <IconHomeTaiLieu />,
        title: "Tài liệu",
        permission: ALL_PERMISSION.MANAGE_DOCMENTARY.permission,
        path: routes.documentary.path,
        keyEnable: ALL_PERMISSION.MANAGE_DOCMENTARY.keyEnable
      },
      {
        icon: <IconHomeThietBi />,
        title: "Thiết bị",
        permission: ALL_PERMISSION.MANAGEMENT_DEVICE.permission,
        path: routes.device.path,
        keyEnable: ALL_PERMISSION.MANAGEMENT_DEVICE.keyEnable
      },
      {
        icon: <IconHomeNhanSu />,
        title: "Nhân sự",
        permission: ALL_PERMISSION.MANAGE_APP_USER.permission,
        path: routes.management.path,
        keyEnable: ALL_PERMISSION.MANAGE_APP_USER.keyEnable
      },
      {
        icon: <IconHomeHoSoPhuongTien />,
        title: "Hồ sơ \nphương tiện",
        permission: ALL_PERMISSION.MANAGE_VEHICLE_RECORD.permission,
        path: routes.vehicleRecords.path,
        keyEnable: ALL_PERMISSION.MANAGE_VEHICLE_RECORD.keyEnable
      },
      {
        icon: <IconHomeCamera />,
        title: "Camera",
        permission: ALL_PERMISSION.MANAGE_CAMERA.permission,
        path: routes.camera.path,
        keyEnable: ALL_PERMISSION.MANAGE_CAMERA.keyEnable
      },
      {
        icon: <IconHomeTinTuc />,
        title: "Tin tức",
        permission: ALL_PERMISSION.MANAGE_NEWS.permission,
        path: routes.news.path,
        keyEnable: ALL_PERMISSION.MANAGE_NEWS.keyEnable
      },
      {
        icon: <IconHomeDanhBa />,
        title: "Danh Bạ",
        permission: ALL_PERMISSION.MANAGE_PHONEBOOK.permission,
        path: routes.phonebook.path,
        keyEnable: ALL_PERMISSION.MANAGE_PHONEBOOK.keyEnable
      },
      {
        icon: <IconHomeCaiDat />,
        title: "Cài đặt",
        permission: ALL_PERMISSION.MANAGE_SETTINGS.permission,
        path: routes.setting.path,
        keyEnable: ALL_PERMISSION.MANAGE_SETTINGS.keyEnable
      },
      {
        icon: <IconHomeTrungTamTroGiup />,
        title: "Trung tâm \ntrợ giúp",
        permission: ALL_PERMISSION.MANAGE_GUIDE.permission,
        link: "https://ttdk-organization.gitbook.io/huong-dan-quan-ly-trung-tam/",
        keyEnable: ALL_PERMISSION.MANAGE_GUIDE.keyEnable
      },
      // {
      //   icon: <IconHomeThongBao />,
      //   title: "Thông báo",
      //   permission: NOT_AUTHENTICATION_PERMISSION,
      //   link: "/notification",
      // },
      {
        icon: <IconHomeChat />,
        title: "Chat",
        permission: ALL_PERMISSION.MANAGE_CHAT.permission,
        link: menuData?.stationSetting?.chatLinkEmployeeToUser,
        keyEnable: ALL_PERMISSION.MANAGE_CHAT.keyEnable
      },
      {
        icon: <IconHomeTorichat />,
        title: "Torichat",
        permission: ALL_PERMISSION.MANAGE_TORICHAT.permission,
        path: routes?.torichat?.path,
        keyEnable: ALL_PERMISSION.MANAGE_TORICHAT.keyEnable
      },
      {
        icon: <IconHomeTiepThiLienKet />,
        title: "Tiếp thị liên kết",
        permission: ALL_PERMISSION.MANAGE_AFFILIATE.permission,
        path: routes?.affiliate?.path,
        keyEnable: ALL_PERMISSION.MANAGE_AFFILIATE.keyEnable
      },
    ];
    menu.forEach((item) => warningPermission(item.permission));
    let newMenu = menu.map((item) => ({
      ...item,
      disabled: !hasPermissionWithSetting(item.permission, item.keyEnable, setting),
    }))
    .sort((a, b) => Number(a.disabled) - Number(b.disabled)); // enabled trước, disabled sau

    // Filter theo setting cho theme HCMTAX
    // if (Object.keys(setting).length > 0 && process.env.REACT_APP_THEME_NAME === "HCMTAX") {
    //   newMenu = newMenu.filter(
    //     (item) => item.keyEnable === NOT_ENABLE_KEY || setting?.[item.keyEnable] === 1
    //   );
    // }

    return newMenu;
  }, [menuData, setting]);

  return (
    <div className="HomeLayout">
      {listMenu.length > 0 ? (
        <div className="HomeLayout__list">
          {listMenu.map((item, index) => (
            <div
                className={`HomeLayout__item ${
                  item.disabled ? "HomeLayout__item--disabled" : ""
                }`}
                onClick={() => {
                  dispatch(
                    setMenu({
                      ...menuData,
                      isShow: false,
                    })
                  );

                  if (item.path) {
                    history.push(item.path);
                    return;
                  }

                  if (item.link) {
                    setUrlForModalDirectLink(item.link);
                  }
                }}
                key={index}
            >
              {item.icon}
              <pre>{item.title}</pre>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
